import axios from "axios";
import { API_URL, TICKET_API_URL, REPORT_API_URL } from "../constants/Constants";

// Main API instance
const instance = axios.create({
  baseURL: API_URL,
  responseType: "json",
  headers: {
    "Content-Type": "application/json",
  },
});

// Ticketing API instance (only needed for different localhost ports)
const ticketingInstance = axios.create({
  baseURL: TICKET_API_URL,
  responseType: "json",
  headers: {
    "Content-Type": "application/json",
  },
});

// Login instance
const loginInstance = axios.create({
  baseURL: API_URL,
  responseType: "json",
  headers: {
    "Content-Type": "application/json",
  }
});

// Report API instance
const reportInstance = axios.create({
  baseURL: REPORT_API_URL,
  responseType: "json",
  headers: {
    "Content-Type": "application/json",
  },
});

// Centralized token setting for all instances
const setTokenToHeader = (token) => {
  instance.defaults.headers.common["x-api-token"] = token;
  ticketingInstance.defaults.headers.common["x-api-token"] = token;
  reportInstance.defaults.headers.common["x-api-token"] = token;
};

if (localStorage.getItem("jwt_token")) {
  setTokenToHeader(localStorage.getItem("jwt_token"));
}

// Deprecated - use setTokenToHeader instead
const setTicketingTokenToHeader = (token) => {
  setTokenToHeader(token);
};

export {
  instance,
  loginInstance,
  ticketingInstance,
  reportInstance,
  setTokenToHeader,
  setTicketingTokenToHeader
};
